export default __webpack_public_path__ + "static/media/HamburgerIcon.8ef24b91.svg";